module.exports = __webpack_public_path__ + "static/media/agenda.032eafc8.png";